/**
 * Platform Admin Module
 *
 * Routes for platform-level administration (DB-backed only; no placeholder UI).
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import SuperAdminLayout from './SuperAdminLayout';
import PlatformDashboard from './PlatformDashboard';
import TenantsBrowser from './TenantsBrowser';
import WorkspacesBrowser from './WorkspacesBrowser';
import CreateWorkspace from './CreateWorkspace';
import CreateTenant from './CreateTenant';
import CreateUser from './CreateUser';
import AdminRolesManager from './AdminRolesManager';

/**
 * Platform Admin App — only routes that exist and are backed by the DB.
 */
export default function PlatformAdminApp() {
  return (
    <Routes>
      <Route element={<SuperAdminLayout />}>
        <Route index element={<PlatformDashboard />} />
        <Route path="tenants" element={<TenantsBrowser />} />
        <Route path="tenants/new" element={<CreateTenant />} />
        <Route path="workspaces" element={<WorkspacesBrowser />} />
        <Route path="workspaces/new" element={<CreateWorkspace />} />
        <Route path="users/new" element={<CreateUser />} />
        <Route path="admin-roles" element={<AdminRolesManager />} />
        <Route path="*" element={<Navigate to="/platform-admin" replace />} />
      </Route>
    </Routes>
  );
}

export { default as SuperAdminLayout } from './SuperAdminLayout';
export { default as PlatformDashboard } from './PlatformDashboard';
export { default as WorkspacesBrowser } from './WorkspacesBrowser';
export { default as CreateWorkspace } from './CreateWorkspace';
